/**
 * Interactions resource (CT-5724): a call or a meeting logged by hand on
 * History, as in the prototype — what it was about and how it went (required),
 * how long it lasted and what was said (optional), files and links. There is no
 * scope field, and no date: it is logged now, and the server dates it. The
 * logged item then arrives in the Activity feed like any other.
 *
 * The path is ASSUMED, `TODO(CT-5724 / backend)`. Real signature, snake_case
 * body; only the transport is stubbed.
 */

import { validateApiResponse } from '../shared/utils/apiResponse.js';
import { request } from './mockTransport.js';

export { __resetMockHistoryForTests, __setMockHistoryScenario } from './__mocks__/history.mock.js';

const PATHS = Object.freeze({
  call: '/v0/profile/interactions/log-call',
  meeting: '/v0/profile/interactions/log-meeting',
});

/**
 * TODO(CT-5724 / backend): `POST /v0/profile/interactions/log-call|log-meeting`
 * with `{ entity_type, entity_id, subject, outcome, duration_seconds | null,
 * summary, attachments: [{ document_id }], links: [{ url }] }`.
 */
export const logInteraction = async ({
  kind,
  entityType,
  entityId,
  subject,
  outcome,
  durationMinutes = null,
  summary = '',
  attachments = [],
  urls = [],
} = {}) => {
  const path = PATHS[kind];
  if (!path) throw new Error(`Unknown interaction ${kind}`);
  const minutes = Number(durationMinutes);
  const response = await request(path, {
    entity_type: entityType,
    entity_id: entityId,
    subject,
    outcome,
    duration_seconds: minutes > 0 ? Math.round(minutes * 60) : null,
    summary,
    attachments: attachments.map((file) => ({ document_id: file.id ?? file })),
    links: urls.map((url) => ({ url })),
  });
  return validateApiResponse(response, 'Failed to log the interaction');
};
